import { createApp } from 'vue';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import VueAxios from 'vue-axios';
import Notifications from '@kyvg/vue3-notification';
import axios from './axios';
import App from './App.vue';
import router from './router';
import store from './store';
import sanitizeHtml from './utils/sanitize';
import './assets/tailwind.css';

const app = createApp(App);

app.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY || 'AIzaSyBqC4_cUWlNZ9PvmDCwkroKLXHfnpe6Wvg',
    libraries: 'places',
  },
});
app.use(Notifications);
app.use(VueAxios, axios);
app.use(store);
app.use(router);

app.config.globalProperties.$sanitizeHtml = sanitizeHtml;

app.mount('#app');
// 🔥 Firebase se inicializa desde el router, no aquí

